<template>
  <VueJsModalPrimary
    v-bind="{ ...getModalAttrs, ...$attrs }"
    v-on="$listeners"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <FormSurveySecondary
      v-on="$listeners"
      :form.sync="form"
      :isUploading="isUploading"
      :step="step"
      @cancel="close"
      @create="$emit('create-survey', form)"
      @done="close"
      @step-forward="stepForward"
      :style="style.form"
    />
  </VueJsModalPrimary>
</template>

<script>
  import { FormSurvey } from '@js/forms/survey'
  import FormSurveySecondary from '@modules/v2/form/form-survey-secondary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalSurveyCreationPrimary',
    inheritAttrs: false,
    components: {
      FormSurveySecondary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        form: new FormSurvey(),
        isUploading: false,
        name: MODAL_WINDOW_NAMES.CREATE_SURVEY_PRIMARY,
        step: 1,
        style: {
          form: {
            padding: Layout.space.lg,
          },
        },
      };
    },
    computed: {
      getModalAttrs: function () {
        return {
          height: '560px',
          maxWidth: 480,
          maxHeight: 560,
          minHeight: 560,
          name: this.name,
        };
      },
    },
    methods: {
      beforeClose: function () {
        this.clearCache();
      },
      beforeOpen: function () {
        this.clearCache();
      },
      clearCache: function () {
        this.step = 0;
        this.form = new FormSurvey();
      },
      close: function () {
        this.clearCache();
        this.$modal.hide(this.name);
      },
      stepForward: function () {
        this.step++;
      },
    },
  };
</script>
